import axios from "axios";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Footer } from "../componentes/footer";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import fondo from "../img/fondo.jpg";
import logo from "../img/logo.png";

const URI =
  process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/password";

const MySwal = withReactContent(Swal);

export const CompRecCont = () => {
  const [dniLogin, setDniLogin] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const recuperarContrasenia = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const logearse = await axios.post(
        URI,
        {
          dni: dniLogin,
          email: emailLogin,
        },
        {
          withCredentials: true,
          credentials: "include",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );

      if (logearse.data.code === 200) {
        setIsLoading(false);
        MySwal.fire({
          text: "Contraseña enviada",
          imageHeight: 65,
          confirmButtonText: "Ok",
          icon: "success",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/");
          }
        });
      } else if (logearse.data.code === 404) {
        setIsLoading(false);

        MySwal.fire({
          text: "Usuario no encontrado. Contáctese con administración.",
          imageHeight: 50,
          confirmButtonText: "Ok",
          icon: "error",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        });
      } else if (logearse.data.code === 400) {
        setIsLoading(false);

        MySwal.fire({
          text: "El correo electrónico no coincide con el registrado. Contáctese con administración.",
          imageHeight: 50,
          confirmButtonText: "Ok",
          icon: "error",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        });
      } else if (logearse.data.code === 403) {
        setIsLoading(false);

        MySwal.fire({
          text: "Solicitud no autorizada",
          imageHeight: 50,
          confirmButtonText: "Ok",
          icon: "error",
          customClass: {
            confirmButton: "btn-confirmar",
          },
        });
      }
    } catch (error) {
      setIsLoading(false);

      MySwal.fire({
        text: "Error en el inicio de sesión",
        confirmButtonText: "Ok",
        icon: "error",
        customClass: {
          confirmButton: "btn-confirmar",
        },
      });
    }
  };

  return (
    <>
    <div
       className="body"
    style={{
      margin: "auto",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <div
        className="container-login-nuevo text-center p-0"
        style={{
          width: "100%",
          maxWidth: "22em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <div className="form-container">
          <img src={logo} alt="Logo" className="form-logo " />
          <h5 className="form-title">Recuperar contraseña</h5>

          {isLoading ? (
            "Enviando contraseña"
          ) : (
            <form
              className="form-login"
              id="LoginForm"
              onSubmit={recuperarContrasenia}
            >
              <input
                type="number"
                placeholder={"DNI"}
                id="dniLogin"
                className="input-login"
                onChange={(e) => setDniLogin(e.target.value)}
                value={dniLogin}
                required
              />{" "}
              <input
                type="email"
                placeholder={"Correo electrónico"}
                id="emailLogin"
                className="input-login"
                onChange={(e) => setEmailLogin(e.target.value)}
                value={emailLogin}
                required
              />{" "}
              <button type="submit" className="btn-login">
                {"Solicitar nueva contraseña"}
              </button>
            </form>
          )}
        </div>{" "}
      </div>
    </div>
    <Footer />
    </>
  );
};
